import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalizeUnderscore' })
export class CapitalizeUnderscorePipe implements PipeTransform {
	transform(value: any): string {
		if (typeof value !== 'string') {
			return value;
		}
		if (value.includes('_')) {
			return value
				.split('_')
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
				.join(' ');
		} else {
			return value.charAt(0).toUpperCase() + value.slice(1);
		}
	}
}
